import { graphql } from 'gql.tada';
import { useQuery } from '@apollo/client';
import { StaffMemberDetailFragment } from './StaffMemberFragment';

const StaffMemberQuery = graphql.persisted(
  "StaffMemberQuery",
  graphql(`
    query StaffMemberQuery($schoolId: ID!, $id: ID!) {
      school(id: $schoolId) {
        id
        slug
        staffMember(id: $id) {
          ...StaffMemberDetailFragment
        }
      }
    }
  `, [StaffMemberDetailFragment])
);

export { StaffMemberQuery };

export function useStaffMemberQuery(schoolId: string | undefined, id: string | undefined) {
  return useQuery(StaffMemberQuery, {
    variables: { schoolId: schoolId!, id: id! },
    skip: !schoolId || !id,
    fetchPolicy: 'cache-and-network',
  });
}
